export default function () {
  if (document.getElementById('page-brand')) {
    import(/* webpackChunkName: "page-brand" */ '../_03_organisms/page-brand/map/main');
  }
}
